import { CheckCircleOutlineOutlined, ErrorOutline } from '@mui/icons-material';
import { Divider, Tooltip, Typography } from '@mui/material';
import { Column, Row } from 'further-ui/components/Layout';
import { numberToCurrencyString } from 'further-ui/utils';

type Props = {
  balanceFromStatement: number | undefined;
  calculatedBalance: number | undefined;
  accountCurrency: string | undefined;
};

const BankAccountBalances: React.FC<Props> = ({
  balanceFromStatement,
  calculatedBalance,
  accountCurrency,
}) => {
  const balancesMatch = balanceFromStatement === calculatedBalance;
  const BalanceIcon = balancesMatch ? CheckCircleOutlineOutlined : ErrorOutline;
  const balanceIconColor = balancesMatch ? 'success' : 'error';
  const balanceTooltipText = balancesMatch
    ? 'Your statement balance and Further-calculated balance match. No action is required at this moment.'
    : 'Your statement balance and Further-calculated balance do not match. This may be because a transaction is missing or duplicated on your bank statement. Please review the system statement against your bank account to identify and fix any discrepancy.';

  return (
    <Row spacing="lg">
      <Column>
        <Row centered spacing="xxs">
          <Typography variant="h6">Latest statement balance</Typography>
          <Tooltip title={balanceTooltipText}>
            <BalanceIcon color={balanceIconColor} fontSize="inherit" />
          </Tooltip>
        </Row>
        <Typography variant="body2" color="grey.900">
          {numberToCurrencyString(balanceFromStatement, {
            currency: accountCurrency,
          })}
        </Typography>
      </Column>
      <Divider flexItem orientation="vertical" />
      <Column>
        <Row centered spacing="xxs">
          <Typography variant="h6">Further-calculated balance</Typography>
          <Tooltip title={balanceTooltipText}>
            <BalanceIcon color={balanceIconColor} fontSize="inherit" />
          </Tooltip>
        </Row>
        <Typography variant="body2" color="grey.900">
          {numberToCurrencyString(calculatedBalance, {
            currency: accountCurrency,
          })}
        </Typography>
      </Column>
    </Row>
  );
};

export default BankAccountBalances;
